export default {"src":"/_next/static/image/src/onboarding/BenefitsOverview/money-back.fa98c641d94d6e08bd91979ae0995886.svg","height":62,"width":60};